module.exports = __webpack_public_path__ + "static/pexels-miguel-á-padriñán-3785935-f1d6520f724898a4dac14f67268f7ace.jpg";